<div class="filters-box">
    <!-- dialog control for mobile only -->
    <button
        #openDialogRef
        class="dialog-control"
        aria-label="Filter"
        i18n-aria-label="@@hermes-global-translations.filter"
        [attr.aria-describedby]="'selected-filters'"
        [attr.aria-expanded]="isDialogDisplayed"
        [attr.aria-haspopup]="'dialog'"
        [attr.aria-controls]="'filter-box-item'"
        (click)="openDialog($event)">
        <span hSrOnlyNoSnippet id="selected-filters">
            {{ selectedFilters }}
            <div i18n="@@hermes.accessibility.selected_filters"> Selected filters </div>
        </span>
        <div class="dialog-control-label" [attr.aria-hidden]="'true'" [attr.role]="'text'">
            <div class="filter-by">
                <span i18n="@@hermes-global-translations.filter"> Filter </span>
                @if (selectedFilters > 0) { ({{ selectedFilters }}) }
            </div>
        </div>

        <div class="dialog-control-svg">
            <h-svg-icon [name]="'arrow-down'"></h-svg-icon>
        </div>
    </button>

    @if (isDialogDisplayed) {
    <div
        [@overlayAnimation]="dialogState"
        (@overlayAnimation.done)="onAnimationEnd($event)"
        class="filters-box-item-wrapper dialog-filters-box"
        id="filter-box-item"
        [cdkTrapFocus]="true"
        [cdkTrapFocusAutoCapture]="true"
        [attr.role]="'dialog'"
        [attr.aria-labelledby]="'filter-box-title'">
        <div class="dialog-filters-box-header">
            <div class="dialog-title-wrapper">
                <button
                    cdkFocusInitial
                    #closeDialogRef
                    aria-label="Close"
                    i18n-aria-label="@@hermes.accessibility.close_tray"
                    (click)="closeDialog($event)">
                    <h-svg-icon [name]="'cross-rounded'"> </h-svg-icon>
                    <span
                        id="filter-box-title"
                        class="filter-box-title heading-4"
                        i18n="@@hermes-global-translations.filter"
                        [attr.role]="'heading'"
                        aria-level="2">
                        Filter
                    </span>
                </button>
            </div>
            <div class="dialog-clear-wrapper">
                <h-grid-filters-clear></h-grid-filters-clear>
            </div>
        </div>

        <div class="dialog-filters-box-body">
            <h-grid-filters-responsive-menu [mobileMode]="true"> </h-grid-filters-responsive-menu>
        </div>

        <div class="dialog-filters-box-footer">
            <h-call-to-action
                (click)="closeDialog($event)"
                [dataTestId]="'Apply'"
                i18n="@@hermes-search-result.button-label">
                Apply
            </h-call-to-action>
        </div>
    </div>
    }
</div>
